<template>
  <a
    :href="href"
    class="logotype"
    :class="{ 'logotype--large': large, 'logotype--white': white }"
  >
    <img :src="src" alt="KERP" class="logotype__image" />
    <div class="logotype__header" v-if="title || subTitle">
      <span class="logotype__title" v-if="title">{{ title }}</span>
      <small class="logotype__subtitle" v-if="subTitle">{{ subTitle }}</small>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    href : {
      required : false,
      default : function () {
        return route('home');
      }
    },
    dataLarge: {
      type: Boolean,
      required: false
    },
    dataWhite: {
      type: Boolean,
      required: false
    },
    src: {
      type: String,
      required: false,
      default: "/images/logo.png"
    },
    title: {
      type: String,
      required: false,
      default: "GALENO"
    },
    subTitle: {
      type: String,
      required: false,
      default: "SISTEMA DE LOGÍSTICA"
    }
  },
  data() {
    return {
      large: this.dataLarge,
      white: this.dataWhite
    };
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/layout/Logo.vue